var map = {
	"./cloud1": "af11",
	"./cloud1.json": "af11",
	"./cloud2": "76c1",
	"./cloud2.json": "76c1",
	"./continents.png": "8dd8",
	"./light.png": "203a",
	"./shadow-1.png": "cb37",
	"./shadow-2.png": "4b9d",
	"./wave.gif": "ec8c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4b9a";